import { DropZoneCsv } from './DropZoneCsv';
import { DropZoneFile } from './DropZoneFile';
import { DropZoneImage } from './DropZoneImage';
import type { DropZoneProps } from './types';
export const DropZone = (props: DropZoneProps) => {
  if (props.variant === 'csv') {
    const {
      dropZoneClassName,
      title,
      subTitle,
      titleClassName,
      subTitleClassName,
      subTitleVariant,
      ...csvProps
    } = props;
    return <DropZoneCsv {...csvProps} dropZoneClassName={dropZoneClassName} title={title} subTitle={subTitle} titleClassName={titleClassName} subTitleClassName={subTitleClassName} subTitleVariant={subTitleVariant} />;
  }
  if (props.variant === 'image') {
    return <DropZoneImage {...props} />;
  }
  return <DropZoneFile {...props} />;
};